import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { ShieldCheck, Key, SignOut } from "@phosphor-icons/react";

const inputCls = "bg-surface-2 border-border text-fg";

export default function Security() {
  const { logout } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!cur || !next) { toast.error("Renseignez votre mot de passe actuel et le nouveau."); return; }
    if (next !== confirm) { toast.error("Les deux nouveaux mots de passe ne correspondent pas."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Mot de passe mis à jour ✅");
      setCur(""); setNext(""); setConfirm("");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="security-page" className="max-w-lg">
      <h1 className="font-display text-3xl font-bold">Sécurité</h1>
      <p className="text-muted text-sm mt-1 mb-6">Gérez votre mot de passe et votre session.</p>

      <div className="surface rounded-lg p-6">
        <div className="flex items-center gap-2 mb-4">
          <Key size={16} className="text-accent" /><span className="font-display font-semibold text-fg">Changer de mot de passe</span>
        </div>
        <div className="space-y-3">
          <div><label className="overline block mb-1.5">Mot de passe actuel</label>
            <Input type="password" className={inputCls} value={cur} onChange={(e) => setCur(e.target.value)} data-testid="security-current" /></div>
          <div><label className="overline block mb-1.5">Nouveau mot de passe</label>
            <Input type="password" className={inputCls} value={next} onChange={(e) => setNext(e.target.value)} data-testid="security-new" />
            <p className="text-[11px] text-muted mt-1">Au moins 11 caractères, avec majuscule, minuscule, chiffre et caractère spécial.</p></div>
          <div><label className="overline block mb-1.5">Confirmer le nouveau mot de passe</label>
            <Input type="password" className={inputCls} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="security-confirm" /></div>
          <button onClick={save} disabled={saving} data-testid="security-save"
            className="flex items-center gap-2 bg-accent text-black font-semibold px-5 py-2.5 rounded-md hover-lift disabled:opacity-60">
            <ShieldCheck size={16} weight="bold" /> {saving ? "Mise à jour…" : "Mettre à jour le mot de passe"}
          </button>
        </div>
      </div>

      <div className="surface rounded-lg p-6 mt-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="font-display font-semibold text-fg">Session</div>
            <p className="text-xs text-muted mt-0.5">Une seule session active à la fois. La déconnexion ferme votre session courante.</p>
          </div>
          <button onClick={logout} data-testid="security-logout"
            className="flex items-center gap-2 text-sm border border-border rounded-md px-4 py-2 text-muted hover:text-destructive hover:border-destructive/40">
            <SignOut size={15} /> Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
}
